module.exports = __webpack_public_path__ + "img/ES1473.24c78b57.png";